export enum TableKey {
  MAIN = 'main',
  MEDIA = 'media',
  COCKPIT = 'cockpit',
}
